module.exports = __webpack_public_path__ + "img/xiehuo.338d9c5b.png";